module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.active_item,
      "collapse": false
    },
    on: {
      "open": _vm.handleOpen,
      "close": _vm.handleClose
    }
  }, [(_vm.sysAdmin) ? _c('el-submenu', {
    attrs: {
      "index": "0"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-monitor"
  }), _vm._v(" "), _c('span', [_vm._v("系统管理")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "udb"
    },
    on: {
      "click": function($event) {
        return _vm.go_to('/#/sys/udb')
      }
    }
  }, [_vm._v("用户搜索")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "users"
    },
    on: {
      "click": function($event) {
        return _vm.go_to('/#/sys/users')
      }
    }
  }, [_vm._v("用户管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "log"
    },
    on: {
      "click": function($event) {
        return _vm.go_to('/#/sys/log')
      }
    }
  }, [_vm._v("日志查询")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "spend"
    },
    on: {
      "click": function($event) {
        return _vm.go_to('/#/user/spend')
      }
    }
  }, [_vm._v("消费记录")])], 2) : _vm._e(), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-school"
  }), _vm._v(" "), _c('span', [_vm._v("数据中心")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "export"
    },
    on: {
      "click": function($event) {
        return _vm.go_to('/#/user/export')
      }
    }
  }, [_vm._v("报告&导出")])], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "2"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-menu"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("交易管理")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "charge"
    },
    on: {
      "click": function($event) {
        return _vm.go_to('/#/user/charge')
      }
    }
  }, [_vm._v("账户充值")])], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "4"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-setting"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("账户设置")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "setting"
    },
    on: {
      "click": function($event) {
        return _vm.go_to('/#/user/setting')
      }
    }
  }, [_vm._v("账户信息")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "password"
    },
    on: {
      "click": function($event) {
        return _vm.go_to('/#/user/password')
      }
    }
  }, [_vm._v("修改密码")])], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9c1b6eca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomeSidebar.vue
// module id = 288
// module chunks = 1